import { useEffect, useState } from "react";

export function getActiveClinicaId() {
  if (typeof window === "undefined") return "";
  return localStorage.getItem("odonto.activeClinicaId") || "";
}

export function useActiveClinicaId() {
  const [activeClinicaId, setActiveClinicaId] = useState(getActiveClinicaId);

  useEffect(() => {
    const sync = () => setActiveClinicaId(getActiveClinicaId());

    window.addEventListener("odonto-clinic-change", sync);
    window.addEventListener("storage", sync);

    return () => {
      window.removeEventListener("odonto-clinic-change", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return activeClinicaId;
}
